import { gql } from '@apollo/client';
export const REMOVE_INVITE = gql `
  mutation RemoveInvite($id: UUID!, $deletedAt: DateTime!) {
    updateUserInvite: updateUserInvite2(id: $id, input: { deletedAt: $deletedAt }) {
      id
    }
  }
`;
